import { useState, useEffect } from 'react';
import styled from 'styled-components';

const TemplateContainer = styled.div`
  font-size: 6pt;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 1in);
  margin: auto;
`;

const DummyTemplate = ({title, height}) => {
  const [time, setTime] = useState(new Date());

  useEffect(()=> {
    setInterval(() => setTime(new Date()), 60000);
  }, [time])

  return (
    <TemplateContainer>
      <p>{title}</p>
      <p>{`STAFF LISTa/o: ${time.toLocaleString('en-US', { dateStyle: "short", timeStyle: "short"})}`}</p>
      <p>Pages {Math.ceil(height/854)}</p>
    </TemplateContainer>
  )
}

export default DummyTemplate;
